// frontend/src/components/AdminRoute.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const AdminRoute = () => {
  const { userInfo } = useSelector((state) => state.auth);

  // console.log('AdminRoute.jsx userInfo', userInfo);

  return userInfo?.isAdmin && !userInfo?.readOnly ? (
    <Outlet />
  ) : (
    <Navigate to='/' replace />
  );
};

export default AdminRoute;
